export default "__VITE_ASSET__BJLgZMa$__"